<template>
  <div :class="`tab ${isBlueLine ? 'blue-line' : ''}`">
    <van-tabs
      animated
      v-model="select"
      @change="change"
      :background="backgroundColor"
      :title-active-color="titleActiveColor"
      :title-inactive-color="titleInactiveColor"
    >
      <van-tab
        title-class="open-top-tabs-title"
        v-for="item in tabList"
        :key="item.index"
        :title="item.title"
        :name="item.index"
      >
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import { Tab, Tabs } from 'vant'
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  props: {
    tabList: {
      type: Array,
      default: () => []
    },
    handleChange: {
      type: Function,
      default: () => {}
    },
    backgroundColor: {
      type: String,
      default: '#3378FF'
    },
    titleActiveColor: {
      type: String,
      default: '#FFFFFF'
    },
    titleInactiveColor: {
      type: String,
      default: 'rgba(220, 220, 220, 0.5)'
    },
    isBlueLine: {
      type: Boolean,
      default: false
    },
    selected: {
      type: [Number, String],
      default: 0
    }
  },
  watch: {
    selected (newValue) {
      this.select = newValue
    }
  },
  data () {
    return {
      select: 0
    }
  },
  mounted () {
    this.select = this.selected || 0
  },
  methods: {
    handleClickTab (type) {
      this.select = type
    },
    change () {
      this.handleChange(this.select)
    }
  }
}
</script>
<style scoped src="./style.less" lang="less">

</style>
